import { useMemo } from "react";
import axios from "axios";
import { message } from "antd";
import { HS_CRM_API_URL } from "../constants/AppConstants";

const useCrmApi = () => {
  const domainUrl = HS_CRM_API_URL;

  const api = useMemo(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const companyId = urlParams.get("companyId");
    const userId = urlParams.get("userId");
    const headers = {
      "Content-Type": "application/json",
    };
    if (companyId && userId) {
      headers["hs-orgId"] = companyId + "_" + userId;
    }

    const axiosInstance = axios.create({
      baseURL: `${domainUrl}/v1`,
      headers,
      withCredentials: true,
    });

    axiosInstance.interceptors.response.use(
      (response) => response,
      async (error) => {
        console.error("API Error:", error);
        if (error.response?.status === 401) {
          console.error("Unauthorized access - Please login again");
          message.error("Unauthorized access - Please login again");
        } else if (error.response?.status === 403) {
          console.error("Forbidden - You don't have permission to access Contacts");
          message.error("Forbidden - You don't have permission to access Contacts");
        } else if (error.code === "ERR_CANCELED") {}

        throw error;
      }
    );

    return axiosInstance;
  }, [domainUrl]);

  return {
    api
  };
};

export default useCrmApi;
